import { render, staticRenderFns } from "./customer-contract-confirm.vue?vue&type=template&id=4c55f28c&scoped=true"
import script from "./customer-contract-confirm.vue?vue&type=script&lang=js"
export * from "./customer-contract-confirm.vue?vue&type=script&lang=js"
import style0 from "./customer-contract-confirm.vue?vue&type=style&index=0&id=4c55f28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55f28c",
  null
  
)

export default component.exports